<template>
  <div class="shop-map" style="padding-bottom: 2px; padding-top: 6px">
    <div class="map-wrapper">
      <div id="shop-map" class="map" />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
// import geo from "@/geo";
import L from "leaflet";
import "leaflet.locatecontrol";
// import "leaflet-edgebuffer";
import "leaflet.awesome-markers";

export default {
  name: "ShopMap",
  components: {},
  data() {
    return {
      uniqueMapID: "shop-map",
      map: undefined,
      locateControl: undefined,
      stateLayer: undefined,
    };
  },
  computed: {
    businesses() {
      return this.$store.getters.getShops;
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  activated() {
    // this.$nextTick(() => this.map.invalidateSize());
    var coords = this.$store.getters.getUserLatLon;
    this.map.setView(coords, 14);
    console.log("activated ShopMap", coords);
    this.redraw();
  },
  mounted() {
    this.initMap();
    EventBus.$on("UPDATE_IOS_LOCATION", (location) => {
      this.map.fire("locationfound", { latlng: location });
    });
    EventBus.$on("UPDATE_SHOP_MAP", () => this.drawMarkers());
    EventBus.$on("TOGGLE_SHOP_MAP", () => this.drawMarkers());
  },
  methods: {
    redraw() {
      // alert("redraw");
      setTimeout(() => this.map.invalidateSize(), 50);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.uniqueMapID, {
        attributionControl: false,
        doubleClickZoom: true,
      });

      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 3,
        maxZoom: 19,
      }).addTo(this.map);
      // this.map.invalidateSize();
      this.stateLayer = L.featureGroup().addTo(this.map);
      this.setupLocateControl();
      var userCoords = this.$store.state.userState;
      this.map.setView(userCoords, 13); // set zoom level 13

      this.drawMarkers();
    },
    drawMarkers() {
      this.drawBusinessMarkers();
      this.redraw();
      // this.map.flyToBounds(this.stateLayer.getBounds());
    },
    drawBusinessMarkers() {
      this.stateLayer.clearLayers(); // clear first
      var defaultProfilePic = `https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png`;
      var defaultBannerPic = `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
      // loop through each business and draw it on the map
      this.businesses.forEach((b) => {
        // L.circleMarker(b, { radius: 1, color: "black" }).addTo(this.stateLayer);
        var triangleIcon = L.divIcon({
          className: "triangle-div-icon",
          iconAnchor: [10, 16],
        });
        L.marker(b, { icon: triangleIcon }).addTo(this.stateLayer);
        var icon = L.icon({
          iconUrl: b.profile_pic_url || defaultProfilePic, // shadowUrl: "leaf-shadow.png",
          className: "profile-pic-round",
          iconSize: [40, 40], // size of the icon // shadowSize: [50, 64],
          iconAnchor: [20, 50], // point of the icon which will correspond to marker's location // shadowAnchor: [4, 62],
          popupAnchor: [0, -50],
        });
        // var icon = L.AwesomeMarkers.icon({
        //   icon: "store-alt",
        //   markerColor: "blue"
        // });
        var marker = L.marker(b, { icon: icon }).addTo(this.stateLayer);
        var opts = { closeButton: false, autoPan: true, maxWidth: "auto" };
        // var txt = `<a href="/shop/${b.id}">${b.name}</a><br>${b.business_type}`;
        var bannerPicURL = b.banner_pic_url || defaultBannerPic;
        var shortName = this.shortenString(b.name, 30);
        var txt = `<div style="width:200px" onclick="leafletRouter('/shop/${b.id}')">
        <a style="font-size:1.25em;">${shortName}</a><br>
        <span style="position:absolute; top:30px; left:8px; font-weight:bold; background-color:white; padding:2px; border-radius:4px; opacity:0.8">${b.business_type}</span>
        <img src='${bannerPicURL}' width="200" style="background-color:rgba(255, 217, 0, 0.5); border-radius:4px" /></div>`;
        marker.bindPopup(txt, opts);
      });
    },
    coloredIcon(o) {
      return L.divIcon({
        html: `<div class="delivery-stop dot${o.vehicle}">${o.ref}</div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
    },
    drawOrderMarker(o) {
      if (!o.dropoff) return;
      // default black icon if order vehicle not yet set
      var icon = L.divIcon({
        html: `<div class='delivery-stop'>${o.ref}</div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      console.log("drawOrder", o.vehicle, this.coloredIcon(o));
      if (o.vehicle > -1) icon = this.coloredIcon(o);
      var coords = { lat: o.dropoff.lat, lng: o.dropoff.lon };
      var m = L.marker(coords, { icon: icon }).addTo(this.stateLayer);
      m.on("click", (e) => {
        this.console("clicked dot", e);
        EventBus.$emit("SELECT_BATCH_ORDER", o.ref);
      });
      var opts = { closeButton: false, autoPan: false };
      var name = `<div style="font-size:1.2em">${o.dropoff.name}</div>`;
      m.bindPopup(name, opts);
      // hide vehicle choosing menu when popup closes
      m.getPopup().on("remove", () => EventBus.$emit("DESELECT_BATCH_ORDER"));
      // scroll bottom to show full map
      this.map.on("click", () => EventBus.$emit("BATCH_SCROLL_BOTTOM"));
      this.map.on("dragstart", () => EventBus.$emit("BATCH_SCROLL_BOTTOM"));
    },
    setupLocateControl() {
      var clickBehavior = {
        inView: "setView",
        outOfView: "inView", //"setView",
        inViewNotFollowing: "inView",
      };
      var options = {
        position: "topright",
        icon: "fa fa-crosshairs",
        enableHighAccuracy: true,
        keepCurrentZoomLevel: true,
        flyTo: true,
        showPopup: true,
        drawCircle: false,
        drawMarker: true, // false for driver only
        showCompass: true, // false for driver only
        clickBehavior: clickBehavior,
        onLocationError: (err) => console.warn("locateControl", err),
      };
      this.locateControl = L.control.locate(options).addTo(this.map);
      this.locateControl.start(); // centers map to user geolocation
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  height: calc(100vh - 163px);
  width: 100%;
}
.map {
  position: relative;
  height: 100%;
  width: 100vw;
  border: 1px solid #209cee;
  border-radius: 5px;
  z-index: 1;
}
</style>

<style>
.profile-pic-round {
  border-radius: 50%;
  border: 1px solid white;
  filter: drop-shadow(1px 1px 2px #555);
}
/* .profile-pic-live {
  border-radius: 50%;
  background: url("../assets/live-stripes.jpg") 30px;
  padding: 1px;
  object-fit: cover;
  filter: drop-shadow(1px 1px 2px #555);
} */
.triangle-div-icon {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 16px solid white;
  filter: drop-shadow(1px 1px 2px #555);
}
.delivery-stop {
  /* margin-top: 10px; */
  font-size: 15px;
  font-weight: bold;
  color: white;
  text-shadow: 1px 1px 3px black;

  height: 26px;
  width: 26px;
  opacity: 0.8;

  border-radius: 50%;
  filter: drop-shadow(1px 1px 1px #555);
  background-color: black;
  opacity: 0.9;
  border-style: solid;
  border-width: 1px;
  border-color: darkslategrey;
}
.leaflet-popup-content {
  padding: 5px 5px;
  margin: 1px 0;
  color: rgb(62, 77, 77);
  /* color: #209cee; */
}
.leaflet-bar a,
.leaflet-bar a:hover {
  text-decoration: none !important;
}
/* colored dots corresponding to vehicle colors, start from 0 */
.dot0 {
  background-color: #1f78b4;
}
.dot1 {
  background-color: #33a02c;
}
.dot2 {
  background-color: #e31a1c;
}
.dot3 {
  background-color: #ff7f00;
}
.dot4 {
  background-color: #a6cee3;
}
.dot5 {
  background-color: #b2df8a;
}
.dot6 {
  background-color: #fb9a99;
}
.dot7 {
  background-color: #fdbf6f;
}
</style>